// Shared helpers for the Harmony Growth components.

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const formatDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatRelative = (iso) => {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const days = Math.floor((Date.now() - then) / 86400000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days} days ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks} week${weeks === 1 ? '' : 's'} ago`;
  return formatDate(iso);
};

// Traffic-light presentation for the notes-cadence coverage status. Keys
// match the `coverage_status` values the backend returns.
export const COVERAGE_STYLES = {
  green:     { label: 'Up to date', dot: 'bg-emerald-500', chip: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  amber:     { label: 'Due soon',   dot: 'bg-amber-500',   chip: 'bg-amber-50 text-amber-700 border-amber-200' },
  red:       { label: 'Overdue',    dot: 'bg-rose-500',    chip: 'bg-rose-50 text-rose-700 border-rose-200' },
  escalated: { label: 'Escalated',  dot: 'bg-rose-700',    chip: 'bg-rose-100 text-rose-900 border-rose-300' },
  never:     { label: 'No notes',   dot: 'bg-slate-400',   chip: 'bg-slate-100 text-slate-700 border-slate-300' },
};

export const NOTE_TYPE_STYLES = {
  recognition: { label: 'Recognition', chip: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  concern:     { label: 'Concern',     chip: 'bg-rose-50 text-rose-700 border-rose-200' },
  neutral:     { label: 'Note',        chip: 'bg-slate-100 text-slate-700 border-slate-300' },
};

export const OUTCOME_LABELS = {
  on_track: 'On track',
  concerns: 'Concerns raised',
  early_exit: 'Recommend early exit',
  confirmed: 'Confirmed',
  extended: 'Extended',
  not_confirmed: 'Not confirmed / exit',
};

export const OUTCOME_STYLES = {
  on_track: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  concerns: 'bg-amber-50 text-amber-700 border-amber-200',
  early_exit: 'bg-rose-50 text-rose-700 border-rose-200',
  confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  extended: 'bg-amber-50 text-amber-700 border-amber-200',
  not_confirmed: 'bg-rose-50 text-rose-700 border-rose-200',
};

export const CHECKPOINT_LABELS = {
  '3_month': '3-month',
  '6_month': '6-month',
  extension: 'Extension',
};

// Quarter boundaries for the awards shortlist.
export const quarterRange = (year, q) => {
  const startMonth = (q - 1) * 3;
  const start = new Date(year, startMonth, 1);
  const end = new Date(year, startMonth + 3, 0);
  const fmt = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { from: fmt(start), to: fmt(end) };
};

export const currentQuarter = () => {
  const d = new Date();
  return { year: d.getFullYear(), quarter: Math.floor(d.getMonth() / 3) + 1 };
};
